module.exports = __webpack_public_path__ + "img/toolIcon.8cc76dc6.png";